/* eslint-disable react/prop-types */
import './index.scss';
import { useState } from 'react';
import { ModalProps } from '../../../types';
import ModalBase from '..';
import ModalExecuteAction from '../ModalExecuteAction';
import { getCurrentDayYear, months } from '../../../helpers/utils/date';
import useHouseMoney from '../../../hooks/useHouseMoney';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { setHouseMoney } from '../../../store/slices/utils';

function ModalFixInterest({ modalIsOpen, setIsOpen, text, allowRender }: ModalProps) {
  if (allowRender === false) return null;
  const [showExecuteAction, setShowExecuteAction] = useState(false);
  const { handleHouseMoneyQuickAction, isLoading } = useHouseMoney();
  const walletsHouseMoney = useSelector((state: RootState) => state.wallets.houseMoney);

  const [, setRentDate] = useState<number>(months.indexOf(walletsHouseMoney?.withdrawalMonth));
  const today = getCurrentDayYear();
  const [fixInterestYear, setFixInterestYear] = useState(today.year);

  const dispatch = useDispatch();

  function closeModal() {
    setRentDate(-1);
    setIsOpen(false);
    setShowExecuteAction(false);
  }

  months[months.indexOf(walletsHouseMoney?.withdrawalMonth)];

  const actionExecuter = (password?: string) => {
    handleHouseMoneyQuickAction(
      closeModal,
      'fix_interest',
      {
        fixInterestYear,
        fixInterestMonth: walletsHouseMoney?.withdrawalMonth,
      },
      password,
    );
  };

  const ModalChildren = () => {
    const onButtonClick = async (e: { preventDefault: () => void }) => {
      e.preventDefault();
      closeModal();
      setShowExecuteAction(true);
    };

    return (
      <div className={`modal-base general success action flex--4`}>
        <span onClick={closeModal}>&times;</span>

        <div className="change-rent-date change-rent-date--alt">
          <h1 className="heading">Fix Interest</h1>
          <p>Select Month and Year</p>
          <div className="date-picker">
            <div className="year-display flex--2">
              <p>{fixInterestYear}</p>
              <div className="year-changee">
                <div onClick={() => setFixInterestYear((interestYear: number) => interestYear + 1)} className="pointer">
                  <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.95152 0.708496L0 4.59431H7.90304L3.95152 0.708496Z" fill="#9CA3AF" />
                  </svg>
                </div>

                <div onClick={() => setFixInterestYear((interestYear: number) => interestYear - 1)} className="pointer">
                  <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.95152 4.29524L7.90304 0.409424H0L3.95152 4.29524Z" fill="#9CA3AF" />
                  </svg>
                </div>
              </div>
            </div>

            <div className="month-select">
              {months.map((month: string, index: number) => {
                return (
                  <p
                    key={`${index}-${month}`}
                    onClick={() => {
                      const selectedMonth = month;
                      dispatch(
                        setHouseMoney({
                          ...walletsHouseMoney,
                          withdrawalMonth: selectedMonth,
                        }),
                      );
                    }}
                    className={months.indexOf(walletsHouseMoney?.withdrawalMonth) === index ? 'active' : ''}
                  >
                    {month}
                  </p>
                );
              })}
            </div>
          </div>
          <div className="button-container">
            <button
              disabled={months.indexOf(walletsHouseMoney?.withdrawalMonth) >= 0 ? false : true}
              onClick={onButtonClick}
            >
              Apply{' '}
              {months.indexOf(walletsHouseMoney?.withdrawalMonth)
                ? walletsHouseMoney?.withdrawalMonth
                : months[today.month]}{' '}
              {fixInterestYear}
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <ModalBase modalIsOpen={modalIsOpen} setIsOpen={setIsOpen}>
        <ModalChildren />
      </ModalBase>

      <ModalExecuteAction
        modalIsOpen={showExecuteAction}
        setIsOpen={setShowExecuteAction}
        text={text}
        action={(password: string) => actionExecuter(password)}
        isLoading={isLoading}
      />
    </>
  );
}

export default ModalFixInterest;
